import { useNavigate } from 'react-router';

import { getDesktopOfflineMapUpdateStatus } from '@/api/offlineMap';
import { useAuth } from '@/context/AuthContext';
import { toast } from '@/components/ui/sonner';
import { useAssetUpdateNotice } from '@/hooks/useAssetUpdateNotice';
import {
  dismissOfflineMapUpdateVersion,
  getDismissedOfflineMapUpdateVersion,
  shouldShowOfflineMapUpdateNotice,
} from '@/utils/offlineMapUpdateNotice';

export default function DesktopOfflineMapUpdateNotice() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useAssetUpdateNotice({
    user,
    fetchUpdateStatus: getDesktopOfflineMapUpdateStatus,
    decide: (updateStatus) => shouldShowOfflineMapUpdateNotice({
      updateStatus,
      user,
      dismissedVersion: getDismissedOfflineMapUpdateVersion(window.localStorage),
      desktopApp: true,
    }),
    notify: ({ publishedVersion, current }) => {
      return toast.info('A newer offline map is available.', {
        description: 'Open Settings → This Device to update it.',
        action: {
          label: 'Open Settings',
          onClick: () => { if (current()) navigate('/settings?section=this-device'); },
        },
        cancel: {
          label: 'Dismiss',
          onClick: () => current() && dismissOfflineMapUpdateVersion(
            publishedVersion,
            window.localStorage,
          ),
        },
        duration: 15000,
      });
    },
    deps: [navigate],
  });

  return null;
}
